import type { GetCurrenciesResult } from './apiSchema';
import type { GetCurrenciesResponse } from './schema';

export function normalizeGetCurrencies(
  data: GetCurrenciesResult,
): GetCurrenciesResponse {
  return data as GetCurrenciesResponse;
}
